import {Box, IconButton, Typography} from '@mui/material';
import {Edit, ErrorOutline} from '@mui/icons-material';
import React, {PropsWithChildren} from 'react';
import {Link} from 'react-router-dom';
import {useReviewContext} from '../../contexts/ReviewContext';
import {useHandoverStyles} from './style';
import {HandoverStepType} from './HandoverStepTypes';

const SummarySectionLink: React.FC<
  PropsWithChildren<{
    step: Exclude<HandoverStepType, 'summary'>;
    editable: boolean;
  }>
> = ({step, children, editable}) => {
  const {
    getHandoverPageURL,
    stepValidation,
    reviewValidation: review,
  } = useReviewContext();
  const styles = useHandoverStyles();
  if (editable) {
    return (
      <Link
        to={getHandoverPageURL(step)}
        style={{
          ...styles.title,
          ...(stepValidation[step] ? {} : styles.titleNotValid),
        }}
      >
        {children}
      </Link>
    );
  }
  return (
    <div
      style={{
        ...styles.title,
        ...(stepValidation[step] ? {} : styles.titleNotValid),
      }}
    >
      {children}
    </div>
  );
};

export const SummarySection: React.FC<
  PropsWithChildren<{
    step: Exclude<HandoverStepType, 'summary'>;
    editable: boolean;
    title: string;
    fullHeight?: boolean;
    test?: string;
    color?: string;
  }>
> = ({step, children, editable, title, fullHeight, test, color}) => {
  const {stepValidation, reviewValidation: review} = useReviewContext();
  const styles = useHandoverStyles();
  return (
    <Box
      data-test={test}
      className="panel"
      sx={{
        ...styles.wrapper,
        ...(stepValidation[step] ? styles.wrapperValid : styles.wrapperNotValid),
        ...(fullHeight ? styles.fullHeight : {}),
      }}
    >
      <SummarySectionLink editable={editable} step={step}>
        {stepValidation[step] ? null : <ErrorOutline color="error" />}
        <Typography color={stepValidation[step] ? 'primary' : 'error'} variant="h5">
          {title}
        </Typography>
        <IconButton
          sx={styles.titleButton}
          style={{opacity: editable ? 1 : 0}}
          color="secondary"
          size="large"
        >
          <Edit />
        </IconButton>
      </SummarySectionLink>
      <div style={styles.wrapperInner}>{children}</div>
    </Box>
  );
};
